var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "atmo-nested-section" },
    [
      _c("h3", { staticClass: "grey-color font-weight-bold mb-3" }, [
        _vm._v("Создание дополнительного соглашения"),
      ]),
      _c(
        "b-overlay",
        {
          attrs: {
            show: _vm.isLoading,
            opacity: "0.6",
            rounded: "",
            "spinner-variant": "primary",
          },
        },
        [
          _c("h5", { staticClass: "grey-color fw-600" }, [
            _vm._v("Измените спецификацию"),
          ]),
          _c(
            "b-form-group",
            [
              _c(
                "fl44-contract-supplementary-agreement-regular-specifications-edit-table",
                {
                  attrs: {
                    v: _vm.$v.form.deliverables,
                    "is-loading": _vm.isLoading,
                  },
                  model: {
                    value: _vm.form.deliverables,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "deliverables", $$v)
                    },
                    expression: "form.deliverables",
                  },
                }
              ),
              _c(
                "b-form-invalid-feedback",
                {
                  staticClass: "mt-3",
                  attrs: { state: !_vm.$v.form.deliverables.$invalid },
                },
                [_vm._v(_vm._s(_vm.specErrorMessage))]
              ),
              _c("text-row-price", {
                attrs: {
                  "label-cols-lg": 4,
                  label: "Стоимость контракта",
                  value: _vm.pivc.purchaseitem.contract.price_total,
                },
              }),
              _c("text-row-price", {
                attrs: {
                  "label-cols-lg": 4,
                  label:
                    "Стоимость контракта с учетом дополнительного соглашения",
                  value: _vm.specSum,
                },
              }),
              _c("form-row-edit-date", {
                attrs: {
                  "label-cols-lg": 4,
                  label: "Дата заключения дополнительного соглашения",
                  v: _vm.$v.form.supplementary_agreement_date,
                  "min-date": _vm.purchase.contract_date,
                  "max-date": _vm.$now(),
                  compact: "",
                },
                model: {
                  value: _vm.form.supplementary_agreement_date,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "supplementary_agreement_date", $$v)
                  },
                  expression: "form.supplementary_agreement_date",
                },
              }),
              _c("form-row-single-line-document-upload", {
                attrs: {
                  "label-cols-lg": 4,
                  v: _vm.$v.form.supplementary_agreement_attachment,
                  title: "Дополнительное соглашение",
                  compact: "",
                },
                model: {
                  value: _vm.form.supplementary_agreement_attachment,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "supplementary_agreement_attachment",
                      $$v
                    )
                  },
                  expression: "form.supplementary_agreement_attachment",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-overlay",
        {
          staticClass: "d-inline-block",
          attrs: {
            show: _vm.isLoading,
            opacity: "0.6",
            rounded: "",
            "spinner-small": "",
            "spinner-variant": "primary",
          },
        },
        [
          _c(
            "b-button",
            {
              staticClass: "text-uppercase mt-1",
              attrs: { variant: "custom-outline-secondary" },
              on: { click: _vm.onCancel },
            },
            [_vm._v("Отмена")]
          ),
          _c(
            "b-button",
            {
              staticClass: "text-uppercase mt-1 ml-2",
              attrs: { variant: "custom-green", disabled: _vm.$v.$invalid },
              on: { click: _vm.createSupplementaryAgreement },
            },
            [_vm._v("Отправить дополнительное соглашение поставщику")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }